import { Paper, Typography } from "@mui/material"
import ProcurementContainer from "../../procurement/containers/ProcurementContainer"
import PaymentRequisitionsList from "../lists/paymentRequisitionsList"
import React from "react";

const PaymentRequisitionsPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
       All Payment Requisitions
      </Typography>
      <Paper sx={{my: 5}}>
        <PaymentRequisitionsList/>
      </Paper>
    </ProcurementContainer>
   
  )
}

export default PaymentRequisitionsPage
